<template lang="pug">
f7-page#privacy-policy
  background
    section
      p 株式会社だんきち(以下,「当社」といいます。)は,「スポともダンス」を提供するサービス(以下,「本サービス」といいます。)におけるプライバシー情報の取扱いについて,以下のとおりプライバシーポリシー(以下,「本ポリシー」といいます。)を定めます。
      p お客様が本サービスを利用するにあたっては、本ポリシーに同意する必要があります。本ポリシーは、お客様と当社との間で合意されるものであり、本サービスを利用するすべてのお客様に適用されます。
      p 本ポリシーに同意するにあたり、本ポリシーの以下のすべての条項をよくお読みください。

    section
      h3 1. お客様から取得する情報
      p 本サービスにおいて、当社はお客様から以下の情報を取得します。
      p 1.1 お客様が当社に直接提供する情報
      p 当社は、お客様が本サービスを利用する際にお客様が提供する以下の情報を取得します。これには氏名、生年月日、性別、ニックネーム、メールアドレス等が含まれます。
      p 1.2 お客様が本サービスを利用する際に当社が取得する情報
      p 当社は、お客様の本サービスの利用および本サービス上での行動に関する情報を取得します。これには、お客様の情報端末、お客様の本サービス上での行動および他のお客様とのやりとり、お客様の投稿された画像及び動画データ、お客様の購入に関する下記の情報が含まれます。
      p 1.2.1 情報端末および接続の環境に関する情報
      p 当社は、お客様の情報端末から、製品モデル、オペレーティングシステム、通信キャリア、情報端末の設定、IPアドレス、その他の情報端末固有の識別子等の情報を取得することがあります。
      p 1.2.2 本サービス上でのお客様の行動および他のお客様（コーチ）とのやりとりに関する情報
      p 当社は、お客様が提供する情報および本サービスの利用履歴を取得します。これには、お客様のレッスンや練習の履歴、投稿された画像及び動画、購入履歴、故障情報が含まれます。
      p 1.2.3 お客様の購入に関する情報
      p お客様が本サービス内で購入を行う場合、支払決済は第三者である決済サービス会社が行うため、当社は、お客様の購入に関する情報（クレジットカード番号等の支払情報、口座の認証情報および請求先住所等の連絡先情報等）を直接入手しませんが、必要に応じて決済サービス会社から事後的に上記情報を取得する場合があります。
      p 1.2.4 クッキー
      p 当社は、お客様が本サービスを利用される際、クッキー（類似の技術を含みます。）を使用することがあります。クッキーは、お客様の情報端末に対してダウンロードされる小さなデータファイルであり、本サービスの機能を安全かつ円滑に動作させるため、また、お客様の希望する設定に関する情報を当社が取得するために使用されます。

    section
      h3 2. 個人情報の第三者への開示・提供の禁止
      p 当社は、次のいずれかに該当する場合を除き、個人情報を第三者に開示致しません。
      p なお、業務委託先への提供の場合は第三者への開示または提供にあたりません。
      p [1] お客様の同意がある場合
      p [2] 法令に基づき開示、提供することを求められた場合
      p [3] お客様や第三者の生命・身体・財産・名誉を損なうおそれがあり、本人の同意を得ることができない場合
      p [4] 情報提供にあたりあらかじめ(1)第三者への提供を利用目的とすること、(2)第三者に提供される個人データの項目、(3)第三者への提供の手段または方法、(4)本人の求めに応じて当該本人が識別される個人データの第三者への提供を停止すること、の情報を本人に通知し、または本人が容易に知りうる状態に置いておくとともに、本人の求めに応じて第三者への提供を停止する場合
      p [5] 統計的なデータなど本人を識別できない状態で開示・提供する場合
      p [6] 合併、会社分割、営業譲渡その他の事由による事業の承継に伴って、提供する場合

    section
      h3 3. 情報の利用目的
      p 当社は、お客様から取得した情報を以下の目的のために利用します。また、当社は、お客様の情報を本ポリシーに規定する目的と関連性のない目的に利用する場合には、あらかじめお客様の同意を取得します。ただし、法令に基づく場合はこの限りではありません。
      p 3.1 本サービスの提供
      p 当社は、お客様から取得する情報を、本サービスの提供や維持、および改善のために利用します。また、当社は、かかる情報を、当社および他のお客様の保護ならびに違法行為の調査および防止のためにも利用します。
      p 3.2 業務および製品の改良ならびに市場調査
      p 当社は、お客様から取得した情報を、当社または第三者による業務および製品の改良、お客様の求めるサービスの提供ならびに新しいサービスの開発のために利用します。
      p 3.3 広告およびマーケティング
      p 当社は、お客様から取得した情報を、当社または第三者の業務およびサービスに関する情報提供のために利用します。この情報提供には、お客様個人に関連する機能の紹介、お客様向けにカスタマイズされたコンテンツの提案や提供およびお客様に特化した広告の提供が含まれます。
      p 3.4 お問い合わせ対応
      p お客様が本サービスを利用する上で生じた問題について当社に対して問い合わせを行った場合には、当社は、かかる問題の解決のためにお客様の情報を利用します。
      p 3.5 統計情報の作成および提供
      p 当社は、お客様から取得した情報を、個人を特定できない統計的な形式に加工することがあります。当該統計情報は、当社の各種サービスや営業またはマーケティング活動、当社または第三者の業務およびサービスの利便性向上または製品の参考等のため、当社または当社より開示を受けた第三者が利用することがあります。

    section
      h3 4. 情報の提供
      p 当社は、以下の場合にお客様（コーチ）の情報を提供することがあります。
      p 4.1 本サービス内で他のお客様に公開する場合
      p お客様が本サービスを利用する場合、生徒のお客様のニックネーム、ダンス歴、ダンスジャンル等の情報、先生の画像、経歴、指導方針のメッセージなどがアプリ内で他のお客様（コーチ）に公開されることがあります。
      p 4.2 取扱いを委託する場合
      p 当社は、委託先企業に、当社の指示に基づきお客様の情報の取扱いを委託することがあります。
      p 4.3 情報収集モジュールや広告配信ツール等を利用する場合
      p 当社は、本サービスの利用に関する動向調査、不正行為防止、お客様への適切な広告表示等のために、第三者の情報収集モジュールや広告配信ツールを利用することがあります。この場合、当該目的のために、以下の事業者に第1条記載のお客様の情報（広告IDを含む情報端末に関する情報・お客様の識別情報・本サービスの利用履歴等）を提供することがあります。
      p - Google  Inc
      p ※プラバシーポリシーへのリンクはページ最下部にあります
      p 4.4 お客様の同意を得た場合
      p 当社は、お客様の同意を得て、お客様の情報を第三者に提供することがあります。
      p 4.5 法令に基づく場合
      p 法令に基づく場合は、お客様の同意を得ることなく、お客様の情報を第三者に提供することがあります。

    section
      h3 5. 情報に関するコントロール
      p 5.1 お客様の情報の開示・訂正等
      p お客様は、本サービス上での操作または本ポリシーに定める当社のお問い合わせ窓口に対しご請求いただくこと等により、当社が取得する情報ならびに当社による当該情報の利用および開示に関して、一定のコントロールを行うことができます。
      p 5.1.1 開示
      p 当社は、お客様本人からお客様の情報の開示を求められたときは、お客様本人に対し遅滞なく開示します。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。なお、アクセスログなどの個人情報以外の情報については原則として開示しません。
      p - ご本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合
      p - 当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合
      p - 他の法令に違反することとなる場合
      p 5.1.2 訂正等
      p 当社は、お客様本人からお客様の情報が真実ではないという理由によって、お客様の情報の内容の訂正・追加または削除（以下「訂正等」といいます）を求められた場合には、他の法令の規定により特別の手続きが定められている場合を除き、利用目的の達成に必要な範囲内において、遅滞なく必要な調査を行い、その結果に基づきお客様の情報の内容の訂正等を行い、その旨を遅滞なく通知します。
      p 5.1.3 利用停止等
      p 当社は、お客様本人からお客様の情報が、あらかじめ公表された利用目的の範囲を超えて取り扱われているという理由、または偽り、その他不正の手段により取得されたものであるという理由により、その利用の停止または消去（以下「利用停止等」といいます）を求められた場合には、遅滞なく必要な調査を行い、その結果に基づき、お客様の情報の利用停止等を行い、その旨ご本人に通知します。
      p ただし、お客様の情報の利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって、お客様の権利利益を保護するために必要な、これに代わるべき措置を取れる場合は、この代替策を講じます。
      p 5.2 クッキーの無効化
      p お客様は、ブラウザーの設定によって、クッキーを無効にしたり、クッキーが送信される場合に警告が行われるようにしたりすることができる場合がありますが、クッキーを無効にした場合、お客様は本サービスの全部または一部の機能を利用できなくなる場合があります。
      p 5.3 分析ツールの無効化
      p 当社は、本ポリシーに基づいてお客様から情報を取得する際に、クッキーや携帯端末用の識別子(類似の技術を含みます。)を用いた第三者の分析ツールを使用することがあります。
      p かかる目的のため、当社は、分析ツールの提供者に対して、それ自体では個人を特定できないお客様の情報を提供する場合があり、当該情報は分析ツールの提供者の定めるプライバシーポリシー等の規定に基づいて取り扱われます。
      p お客様は、性質上または技術上困難な場合を除き、当社または分析ツールの提供者が提供する方法(以下の方法を含みます。)によって、分析ツールの提供者へのお客様の情報の提供を停止することができます。
      p Google Analytics(ディスプレイ広告主向け機能を含む)
      p - 提供者:Google
      p - クッキーの収集および利用方法:Google社のページに規定

    section
      h3 6. 情報の保護
      p 当社は、お客様の情報を滅失、窃取、悪用、不正アクセス、漏えい、改ざんおよび毀損から保護するために必要な合理的な措置を講じます。

    section
      h3 7. お客様の情報の保有と移転
      p お客様の情報は、本ポリシーに従って、第2条に定める利用目的を達成するために必要な範囲において、当社の委託先企業および当社と資本関係のある会社において保有および取り扱われることになります。
      p この場合、当社は適用法令の要求するところに従い、お客様の情報を保護するために必要な適切な措置を講じます。

    section
      h3 8. 本ポリシーの変更
      p 当社は、本ポリシーを随時変更できるものとします。
      p 変更後の本ポリシーは、本サービス内に掲示することとし、当該掲示がなされた時点からその効力を生じるものとします。本サービスを利用される際には、随時最新の本ポリシーをご確認ください。

    section
      h3 9. お問い合わせ
      p 本ポリシーに関するお問い合わせは、下記までお願いいたします。
      p 〒566-0024 大阪府摂津市正雀本町1-38-10 ISAKU1-202
      p 株式会社だんきち
      p 電話番号:06-6836-7044
      p メール :&nbsp;
        a(class="external" href="mailto:spotomo_support@dank-1.com") spotomo_support@dank-1.com
      p 以上

    section.links
      h3 リンク
      f7-link(href="https://policies.google.com/privacy" external)
        | Googleプライバシーポリシーリンク
</template>

<style lang="scss" scoped>
@import '@/styles/public-common.scss';
</style>

<script>
import PageTitle from '@/components/mixins/PageTitle'

export default {
  mixins: [PageTitle],
  title: 'プライバシーポリシー',
}
</script>
